import Vue from 'vue';
import CategoriesREST from './customREST/categories';
import ItemsREST from './customREST/items';
import WorkOrderItemsREST from './customREST/workorderitems';
import OrderItemsREST from './customREST/orderitems';
import OrderReceptionsREST from './customREST/orderreceptions';
import OrdersREST from './customREST/orders';
import OrderMessagesREST from './customREST/ordermessages';
import OrderReceptionOrderItemsREST from './customREST/orderreceptionorderitems';
import WorkOrdersREST from './customREST/workorders';
import AlertsREST from './customREST/alerts';
import UsersREST from './customREST/users';
import ItemSuppliersREST from './customREST/itemsuppliers';
import ItemSupplierPriceHistoriesREST from './customREST/itemsupplierpricehistories';
import DashboardsREST from './customREST/dashboards';
import KeyGenREST from './customREST/keygen';
import WorkOrderItemOrderItemsREST from './customREST/workorderitemorderitems';
import ImagesREST from './customREST/images';
import ReportsREST from './customREST/reports';

import ItemsActions from './actions/items';
import OrdersActions from './actions/orders';
import OrderItemsActions from './actions/orderitems';
import WorkOrdersActions from './actions/workorders';
import WorkOrderItemsActions from './actions/workorderitems';
import WorkOrderItemOrderItemsActions from './actions/workorderitemorderitems';
import ImportationsActions from './actions/importations';

//If you add a custom repository in this array it will be dynamically added to the repository custom options when get: is called.
const customRESTrepositories = {
  categories: CategoriesREST,
  items: ItemsREST,
  workorderitems: WorkOrderItemsREST,
  orderitems: OrderItemsREST,
  orders: OrdersREST,
  ordermessages: OrderMessagesREST,
  workorders: WorkOrdersREST,
  orderreceptions: OrderReceptionsREST,
  alerts: AlertsREST,
  users: UsersREST,
  itemsuppliers: ItemSuppliersREST,
  itemsupplierpricehistories: ItemSupplierPriceHistoriesREST,
  keygen: KeyGenREST,
  dashboards: DashboardsREST,
  orderreceptionorderitems: OrderReceptionOrderItemsREST,
  workorderitemorderitems: WorkOrderItemOrderItemsREST,
  images: ImagesREST,
  reports: ReportsREST,
};

//If you add a custom repository in this array it will be dynamically added to the repository custom options when get: is called.
const actionsRepositories = {
  items: ItemsActions,
  orders: OrdersActions,
  orderitems: OrderItemsActions,
  workorders: WorkOrdersActions,
  workorderitems: WorkOrderItemsActions,
  importations: ImportationsActions,
  workorderitemorderitems: WorkOrderItemOrderItemsActions,
};

class Repository {
  //Generate a repository for the resource (The /controller route with all the main and custom routes)
  constructor(resource) {
    this.resource = resource;
    this.customREST = customRESTrepositories[resource];
    this.actions = actionsRepositories[resource];
  }

  getAll(filters = null) {
    let filtersString = this.formatFilters(filters);

    return Vue.prototype.$axiosMainClient.get(
      `${this.resource}?` + filtersString
    );
  }
  get(idPublic) {
    return Vue.prototype.$axiosMainClient.get(`${this.resource}/${idPublic}`);
  }
  create(payload) {
    return Vue.prototype.$axiosMainClient.post(`${this.resource}`, payload);
  }
  update(payload, idPublic) {
    return Vue.prototype.$axiosMainClient.put(
      `${this.resource}/${idPublic}`,
      payload
    );
  }
  patch(id, payload) {
    return Vue.prototype.$axiosMainClient.patch(
      `${this.resource}/${id}`,
      payload
    );
  }
  delete(idPublic) {
    return Vue.prototype.$axiosMainClient.delete(
      `${this.resource}/${idPublic}`
    );
  }
  formatFilters(filters) {
    if (filters === null) return '';

    return Object.keys(filters)
      .map((key) => {
        if (filters[key] != null && filters[key]?.length != 0) {
          if (Array.isArray(filters[key])) {
            let listArray = [];
            for (let item of filters[key]) {
              listArray.push(key + '=' + item);
            }
            return listArray.join('&');
          } else {
            return key + '=' + filters[key];
          }
        } else {
          return '';
        }
      })
      .filter((x) => {
        return x != '';
      })
      .join('&');
  }
}

//When you get any repository with his name in parameter it will generate a repository with all the default and custom routes.
export default {
  get: (name) => {
    return new Repository(name);
  },
};
